const requiredKeywords = [
  { platform: "google", type: "brands" },
  { platform: "google", type: "competitors" },
  { platform: "google", type: "categories" },
  { platform: "instagram", type: "competitors" },
]

export const checkForMissingKeywords = (
  keywords: Record<string, Record<string, unknown[]>>,
) =>
  requiredKeywords.some(
    ({ platform, type }) => !keywords[platform]?.[type]?.length,
  )
